import { NgModule, ModuleWithProviders } from '@angular/core';
import { FishCollapse } from './collapse';

export { FishCollapse } from './collapse';


export class FishCollapseModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishCollapseModule, providers: [] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{ declarations: [FishCollapse], exports: [FishCollapse] }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
